var _style, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200.8 252.3",
    style: {
      enableBackground: "new 0 0 200.8 252.3"
    },
    xmlSpace: "preserve",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0.4,
    y1: -1.1,
    x2: 200.1,
    y2: 199.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0.4,
    y1: 199.7,
    x2: 200.1,
    y2: -1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 71.1,
    y1: -1.1,
    x2: 70.8,
    y2: 199.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 100.4,
    y1: -1.1,
    x2: 100.2,
    y2: 199.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 129.6,
    y1: -1.1,
    x2: 129.3,
    y2: 199.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0.4,
    y1: 69.8,
    x2: 200.1,
    y2: 69.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0.4,
    y1: 99,
    x2: 200.1,
    y2: 98.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 0.1,
    y1: 128.9,
    x2: 199.9,
    y2: 128.3
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.4,214.1h-142c-9.4,0-17-7.6-17-17v-142c0-9.4,7.6-17,17-17h142c9.4,0,17,7.6,17,17v142 C188.4,206.5,180.8,214.1,171.4,214.1z M29.4,48.1c-3.9,0-7,3.1-7,7v142c0,3.9,3.1,7,7,7h142c3.9,0,7-3.1,7-7v-142c0-3.9-3.1-7-7-7 C171.4,48.1,29.4,48.1,29.4,48.1z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.3,134.3l-6.9,21h-8.9l22.8-66.9h10.3l22.8,66.9h-9.2l-7.1-21C101,134.3,77.3,134.3,77.3,134.3z M99.3,127.6l-6.6-19.2 c-1.5-4.4-2.5-8.3-3.5-12.2H89c-1,3.9-2,8-3.4,12.1l-6.5,19.3L99.3,127.6L99.3,127.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,93.8c0,3-2.1,5.4-5.6,5.4c-3.2,0-5.3-2.4-5.3-5.4s2.2-5.5,5.5-5.5C134.2,88.4,136.3,90.8,136.3,93.8z M126.6,155.3 v-48h8.7v48L126.6,155.3L126.6,155.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/AiIcon.fc30ba388184bcf26c2a500449ec5960.svg";
export { ForwardRef as ReactComponent };